<template>
  <sh-fieldset>
    <location-selector
      :favoriteVenues="favoriteVenues"
      :houses="houses"
      :citiesWithoutHouses="citiesWithoutHouses"
      :localHouse="localHouse"
      v-model="selectedVenues"
      >
      <template slot="favorite-title">{{ $t('EXPLORE_EVENTS_FILTER_MY_HOUSES_LABEL') }}</template>
      <template slot="all-title">{{ $t('EXPLORE_EVENTS_FILTER_ALL_HOUSES_LABEL') }}</template>
    </location-selector>
  </sh-fieldset>
</template>

<script>
import LocationSelector from '~/components/location-selector'
import ShFieldset from '~/components/fieldsets'

export default {
  components: {
    LocationSelector,
    ShFieldset
  },

  props: {
    favoriteVenues: {
      type: Array,
      required: false
    },
    houses: {
      type: Array,
      required: true
    },
    citiesWithoutHouses: {
      type: Array,
      required: false,
      default: () => []
    },
    localHouse: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    }
  },

  computed: {
    selectedVenues: {
      get () {
        return this.value
      },

      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style>

</style>
